import React, { useEffect, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const SystemExpHalf = (props) => {
  const chartRef = useRef(null);
  const [currentData, setCurrentData] = useState(props.data);
  const [prevData, setPrevData] = useState(props.data);

  useEffect(() => {
    // Check if props.data is different from the previous value
    if (props.data !== prevData) {
      // Update the currentData state with the new props.data value
      setCurrentData(props.data);
      // Update the prevData state to match the new props.data value
      setPrevData(props.data);
    }
  }, [props.data, prevData]);
  useEffect(() => {
    const chartOptions = {
      legend: {
        enabled: false,
      },
      chart: {
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        backgroundColor: "transparent",
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
      },
      tooltip: {
        formatter: function () {
          return '<span style="font-weight: bold;">' + 'System Experience :' + '</span><br>' + this.y;
        },
      },
      pane: {
        center: ["50%", "75%"],
        size: "100%",
        startAngle: -90,
        endAngle: 90,
        background: {
          borderWidth: 0,
          backgroundColor: {
            radialGradient: {
              cx: 0.1,
              cy: 0.5,
              r: 0.9,
            },
            stops: [
              [0, "#eb5317"],
              [1, "#64d9cd"],
            ],
          },
          innerRadius: "40%",
          outerRadius: "100%",
          shape: "arc",
        },
      },
      yAxis: [
        {
          lineWidth: 0,
          min: 0,
          max: 100,
          minorTickLength: 0,
          tickLength: 0,
          tickWidth: 0,
          labels: {
            enabled: false,
          },
          title: {
            text: "",
            useHTML: false,
            y: 80,
          },
          pane: 0,
        },
      ],
      plotOptions: {
        pie: {
          borderWidth: 0,
          colors: [
            {
              radialGradient: {
                cx: 0.1,
                cy: 0.5,
                r: 0.9,
              },
              stops: [
                [0, "#eb5317"],
                [1, "#64d9cd"],
              ],
            },
          ],
          dataLabels: {
            enabled: false,
            distance: -30,
            format: "{point.y}",
            style: {
              fontWeight: "bold",
              color: props?.color,
              textShadow: "0px 1px 2px black",
           
            },
          },
          startAngle: -90,
          endAngle: 90,
          center: ["50%", "75%"],
        },
        gauge: {
          dataLabels: {
            enabled: false,
          },
          dial: {
            radius: "100%",
            baseLength: "0%",
            rearLength: "0%",
            baseWidth: 10,
            topWidth: 1,
            backgroundColor: props?.color,
            borderColor:props?.color,
           
          },
        },
      },
      series: [
        {
          // type: "pie",
          name: "Experience",
          innerSize: "50%",
          data: [
            {
              name: "Value",
              y:props?.data , // Change this value to the desired value (between 0 and 100)
              color: {
                radialGradient: {
                  cx: 0.1,
                  cy: 0.5,
                  r: 0.9,
                },
                stops: [
                  [0, "#eb5317"],
                  [1, "#64d9cd"],
                ],
              },
            },
          ],
        },
        {
          type: "gauge",
          data: [props?.data], // Change this value to the desired value (between 0 and 100)
          dial: {
            rearLength: 0,
          },
        },
      ],
    };

    if (chartRef.current) {
      const chart = Highcharts.chart(chartRef.current, chartOptions);
      return () => {
        chart.destroy();
      };
    }
  }, [prevData]);

  return (
    <div style={{ position: "relative" }}>
      <div
        ref={chartRef}
        style={{ height: "280px", marginTop: "-50px", marginBottom: "-60px" }}
      ></div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          width: "100%",
          top: "70%",
          marginTop:'10px'
        }}
      >
        <div className={window.location.pathname === '/user/profile-analytics'? 'pro-weak' : 'weak'} 
        style={{ color: props?.color }}
        >WEAK</div>
        <div className={window.location.pathname === '/user/profile-analytics'? 'pro-strong' : 'strong'}
        style={{  color: props?.color }}
        >STRONG</div>
      </div>
    </div>
  );
};

export default SystemExpHalf;
